import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, unref as _unref, createElementVNode as _createElementVNode, withKeys as _withKeys, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createElementBlock as _createElementBlock, resolveDirective as _resolveDirective, withDirectives as _withDirectives, normalizeClass as _normalizeClass, withModifiers as _withModifiers, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-c7096632"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "flex-column align-center" }
const _hoisted_2 = { class: "page-title mb-3 text-left" }
const _hoisted_3 = { class: "sentence-container" }
const _hoisted_4 = { class: "sentence-part" }
const _hoisted_5 = { class: "sentence-part" }
const _hoisted_6 = { class: "nav-container mt-3" }
const _hoisted_7 = { key: 1 }
const _hoisted_8 = { class: "sentence-container" }
const _hoisted_9 = { class: "sentence-part" }
const _hoisted_10 = { class: "bold-answer" }
const _hoisted_11 = {
  key: 0,
  class: "sentence-part"
}

import { computed, onMounted, ref } from "vue";
import { useCourseStore } from "@/store/courseStore";
import axios from "axios";
import { useRouter } from "vue-router";
import { useI18n } from "vue-i18n";
import DailyMilestoneBar from "@/components/DailyMilestoneBar.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'SentenceView',
  setup(__props) {

const userInput = ref("");
const correctAnswer = ref(false);
const incorrectAnswer = ref(false);
const showHint = ref(false);
const showCorrectAnswer = ref(false);

const router = useRouter();
const dialogMessage = ref("");
const displayPopup = ref(false);

const courseStore = useCourseStore();
const courseName = courseStore.currentCourse?.name;
const topicName = courseStore.currentTopic?.name;
const courseType = courseStore.currentCourse?.type;
const isSchoolUser = computed(() => courseStore.isSchoolUser);

const topic = ref();
const learnedSentences = ref(0);
const totalWords = ref(0);
const topicProgressPercentage = ref("0");

const { t } = useI18n();

onMounted(async () => {
  // console.log(
  //   `Course ID: ${courseStore.currentCourse.id}, Topic ID: ${courseStore.currentTopic.id}`,
  // );
  await fetchNewSentence();
  await getTopic();
});

const formSubmitted = async () => {
  if (!correctAnswer.value && userInput.value !== "") {
    await handleKeyUp();
  }
};

async function fetchNewSentence() {
  // console.log(
  //   `fetchNewSentence called. Course ID: ${courseStore.currentCourse.id}, Topic ID: ${courseStore.currentTopic.id}`,
  // );
  correctAnswer.value = false;
  incorrectAnswer.value = false;
  showCorrectAnswer.value = false;
  userInput.value = "";
  axios
    .get(
      `/api/course/${courseStore.currentCourse?.id}/topics/${courseStore.currentTopic?.id}/sentence`,
    )
    .then((response) => {
      if (
        response.status === 200 &&
        (!response.data || Object.keys(response.data).length === 0)
      ) {
        displayPopup.value = true;
        dialogMessage.value = t("sentenceView.allLearnedMessage");
        setTimeout(() => {
          displayPopup.value = false;
          router.push("/course");
        }, 3000);
        return;
      }

      // console.log(
      //   `Sentence ID: ${response.data.id}, Sentence: ${JSON.stringify(response.data)}`,
      // );
      sentenceId.value = response.data.id;
      const sentenceParts = response.data.textEt.split("x");
      sentencePart1.value = sentenceParts[0];
      sentencePart2.value = sentenceParts[1] || "";
      russianWord.value = response.data.valueRu;
      russianFullSentence.value = response.data.textRu;
    })
    .catch((error) => {
      console.error("Failed to fetch sentence", error.message);
    });
}

async function getTopic() {
  try {
    const response = await axios.get(
      `api/course/${courseStore.currentCourse?.id}/topics`,
    );
    const topics = response.data;

    //Find the current topic from the list of received topics
    topic.value = topics.find(
      (topic) => topic.id === courseStore.currentTopic?.id,
    );

    if (topic.value) {
      learnedSentences.value = topic.value.completedSentences || 0;
      totalWords.value = topic.value.wordCount || 0;
      topicProgressPercentage.value = totalWords.value
        ? Math.min(
            (learnedSentences.value / totalWords.value) * 100,
            100,
          ).toFixed(1)
        : "0";
      window.dispatchEvent(new Event("update-progress"));
    } else {
      console.error("Failed to find current topic in the list");
    }
  } catch (error) {
    console.error("Failed to fetch topics", error.message);
  }
}

// Variables for dynamic content from the backend
const sentenceId = ref("");
const sentencePart1 = ref("");
const sentencePart2 = ref("");
const russianWord = ref("");
const russianFullSentence = ref("");
const correctAnswerValue = ref("");

async function checkAnswer() {
  await axios
    .post(
      `/api/course/${courseStore.currentCourse?.id}/topics/${courseStore.currentTopic?.id}/sentence`,
      { sentenceId: sentenceId.value, guessValue: userInput.value },
    )
    .then((response) => {
      if (response.data.guessStatus === "CORRECT") {
        correctAnswer.value = true;
      } else {
        incorrectAnswer.value = true;
      }
      correctAnswerValue.value = response.data.correctValue;
      showCorrectAnswer.value = true;
    })
    .catch((error) => {
      console.error("Failed to check sentence", error.message);
    });
}

async function showHintText() {
  await axios
    .post(
      `/api/course/${courseStore.currentCourse?.id}/topics/${courseStore.currentTopic?.id}/sentence`,
      { sentenceId: sentenceId.value, guessValue: userInput.value },
    )
    .then((response) => {
      correctAnswerValue.value = response.data.correctValue;
    });
  showHint.value = true;
  showCorrectAnswer.value = true;
}

const handleKeyUp = async () => {
  if (userInput.value !== "") {
    await new Promise((r) => setTimeout(r, 100));
    await checkAnswer();
    await getTopic();
  } else {
    await new Promise((r) => setTimeout(r, 100));
    await showHintText();
  }
};

return (_ctx: any,_cache: any) => {
  const _component_v_card_text = _resolveComponent("v-card-text")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_dialog = _resolveComponent("v-dialog")!
  const _component_v_progress_circular = _resolveComponent("v-progress-circular")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_text_field = _resolveComponent("v-text-field")!
  const _component_v_divider = _resolveComponent("v-divider")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_card_actions = _resolveComponent("v-card-actions")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_container = _resolveComponent("v-container")!
  const _directive_focus = _resolveDirective("focus")!

  return (_openBlock(), _createBlock(_component_v_container, { class: "my-container" }, {
    default: _withCtx(() => [
      _createVNode(_component_v_dialog, {
        modelValue: displayPopup.value,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((displayPopup).value = $event)),
        "max-width": "600px"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_v_card, { variant: "elevated" }, {
            default: _withCtx(() => [
              _createVNode(_component_v_card_text, null, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(dialogMessage.value), 1)
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["modelValue"]),
      _createVNode(DailyMilestoneBar),
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("form", {
          onSubmit: _withModifiers(formSubmitted, ["prevent"]),
          onKeydown: _cache[2] || (_cache[2] = _withKeys(_withModifiers(() => {}, ["prevent"]), ["enter"]))
        }, [
          (!showCorrectAnswer.value)
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                _createElementVNode("h1", _hoisted_2, _toDisplayString(_unref(courseName)) + ". " + _toDisplayString(_unref(topicName)), 1),
                _createVNode(_component_v_card, {
                  variant: "elevated",
                  class: "mt-3 mb-3 my-card"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_col, { style: {"display":"flex","justify-content":"end","padding":"6px"} }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_progress_circular, {
                          rotate: 360,
                          size: 60,
                          width: 6,
                          "model-value": topicProgressPercentage.value,
                          color: isSchoolUser.value ? '#FEC331' : '#9575CD',
                          "bg-color": isSchoolUser.value ? '#E0E0E0' : undefined
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(topicProgressPercentage.value) + "% ", 1)
                          ]),
                          _: 1
                        }, 8, ["model-value", "color", "bg-color"])
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_v_card_text, null, {
                      default: _withCtx(() => [
                        _createElementVNode("div", _hoisted_3, [
                          _createElementVNode("span", _hoisted_4, _toDisplayString(sentencePart1.value), 1),
                          (!correctAnswer.value)
                            ? (_openBlock(), _createBlock(_component_v_text_field, {
                                key: 0,
                                modelValue: userInput.value,
                                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((userInput).value = $event)),
                                class: "ml-3 mr-3 sentence-text-field",
                                placeholder: _ctx.$t('sentenceView.wordPlaceholder'),
                                variant: "underlined",
                                autofocus: "",
                                onKeyup: _withKeys(handleKeyUp, ["enter"])
                              }, null, 8, ["modelValue", "placeholder"]))
                            : _createCommentVNode("", true),
                          _createElementVNode("span", _hoisted_5, _toDisplayString(sentencePart2.value), 1)
                        ])
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_v_card_text, { class: "my-card-text" }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(russianWord.value), 1)
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_v_divider),
                    _createVNode(_component_v_card_text, null, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(russianFullSentence.value), 1)
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_v_card_actions, { style: {"display":"flex","justify-content":"end"} }, {
                      default: _withCtx(() => [
                        (!correctAnswer.value && userInput.value !== '')
                          ? (_openBlock(), _createBlock(_component_v_btn, {
                              key: 0,
                              onClick: checkAnswer,
                              variant: "outlined",
                              class: "text-none my-btn"
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(_ctx.$t("sentenceView.checkAnswer")), 1)
                              ]),
                              _: 1
                            }))
                          : (!correctAnswer.value)
                            ? (_openBlock(), _createBlock(_component_v_btn, {
                                key: 1,
                                onClick: showHintText,
                                variant: "outlined",
                                class: "text-none my-btn"
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(_ctx.$t("sentenceView.showAnswer")), 1)
                                ]),
                                _: 1
                              }))
                            : _createCommentVNode("", true)
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createElementVNode("div", _hoisted_6, [
                  _createVNode(_component_router_link, {
                    to: "/course",
                    class: "mr-4"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.$t("sentenceView.topics")), 1)
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_router_link, {
                    to: _unref(courseType) === 'LANGUAGE_LEVEL' ? '/courses' : '/exercises',
                    class: "mr-4"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_unref(courseType) === "LANGUAGE_LEVEL"
                  ? _ctx.$t("sentenceView.courses")
                  : _ctx.$t("sentenceView.exercises")), 1)
                    ]),
                    _: 1
                  }, 8, ["to"])
                ])
              ], 64))
            : (_openBlock(), _createElementBlock("div", _hoisted_7, [
                (correctAnswer.value)
                  ? (_openBlock(), _createBlock(_component_v_icon, {
                      key: 0,
                      color: "green-darken-2",
                      size: "50px"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode("mdi-check-circle-outline")
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true),
                (incorrectAnswer.value)
                  ? (_openBlock(), _createBlock(_component_v_icon, {
                      key: 1,
                      color: "red-darken-2",
                      size: "50px"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode("mdi-close-circle-outline")
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true),
                _createVNode(_component_v_card, {
                  class: _normalizeClass([{
              'green-border': showCorrectAnswer.value && userInput.value !== '',
              'red-border': incorrectAnswer.value && userInput.value !== '',
            }, "mt-3 mb-3 my-card"]),
                  variant: "elevated"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_col, { style: {"display":"flex","justify-content":"end","padding":"6px"} }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_progress_circular, {
                          rotate: 360,
                          size: 60,
                          width: 6,
                          "model-value": topicProgressPercentage.value,
                          color: isSchoolUser.value ? '#FEC331' : '#9575CD',
                          "bg-color": isSchoolUser.value ? '#E0E0E0' : undefined
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(topicProgressPercentage.value) + "% ", 1)
                          ]),
                          _: 1
                        }, 8, ["model-value", "color", "bg-color"])
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_v_card_text, null, {
                      default: _withCtx(() => [
                        _createElementVNode("div", _hoisted_8, [
                          _createElementVNode("span", _hoisted_9, [
                            _createTextVNode(_toDisplayString(sentencePart1.value) + " ", 1),
                            _createElementVNode("span", _hoisted_10, _toDisplayString(correctAnswerValue.value), 1)
                          ]),
                          (showHint.value || showCorrectAnswer.value)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_11, _toDisplayString(sentencePart2.value), 1))
                            : _createCommentVNode("", true)
                        ])
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_v_divider),
                    _createVNode(_component_v_card_text, null, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(russianFullSentence.value), 1)
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_v_card_actions, { style: {"display":"flex","justify-content":"end"} }, {
                      default: _withCtx(() => [
                        _withDirectives((_openBlock(), _createBlock(_component_v_btn, {
                          onClick: fetchNewSentence,
                          onKeyup: _withKeys(fetchNewSentence, ["enter"]),
                          variant: "outlined",
                          class: "text-none my-btn",
                          type: "button"
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_ctx.$t("sentenceView.next")), 1)
                          ]),
                          _: 1
                        })), [
                          [_directive_focus]
                        ])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }, 8, ["class"])
              ]))
        ], 32)
      ])
    ]),
    _: 1
  }))
}
}

})